<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Service agreement details"></fury-breadcrumbs>
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>
        <div [style.display]="loader  ? 'block' : 'none'">
            Please wait...
        </div>
        <div [style.display]="!loader  ? 'block' : 'none'">
            <div class="aggreedetail">
                <label>Title: </label> {{agreementDetails?.title}}
            </div>
            <div class="aggreedetail">
                <label>Order: </label> {{agreementDetails?.order}}
            </div>
            <div class="aggreedetail">
                <label>Content: </label>
                <div class="content" [innerHTML]="agreementDetails?.content"></div>
                <ng-container *ngFor="let item of agreementDetails?.coveredItemDetail">
                    <h5>{{item?.title}}</h5>
                    <div class="content" [innerHTML]="item?.content"></div>
                </ng-container>
            </div>
        </div>
    </fury-page-layout-content>
</fury-page-layout>


<!-- <fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Service agreement details</span>
    </fury-title>
  </fury-page>
        <div [style.display]="loader  ? 'block' : 'none'">
            Please wait...
        </div>
    <div [style.display]="!loader  ? 'block' : 'none'">
        <div>
            <label>Title: </label> {{agreementDetails?.title}}
        </div>
        <div>
            <label>Order: </label> {{agreementDetails?.order}}
        </div>
        <div>
            <label>Content: </label>
            <div class="content" [innerHTML]="agreementDetails?.content"></div>
        </div>
    </div> -->

